import * as React from "react"
import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "./Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import DataTable from "@/components/Tables/DataTable"
import { JSONTree } from "react-json-tree"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Divider,
  Box,
} from "@mui/material"

export default function ActivityLogs() {
  return (
    <>
      <CrudProvider>
        <SystemLog />
      </CrudProvider>
    </>
  )
}

function SystemLog() {
  const { data: response, isLoading } = useCustomQuery(
    ["activity-logs"],
    "activity-logs"
  )

  const [selectedLog, setSelectedLog] = React.useState(null)
  const [isPopupOpen, setPopupOpen] = React.useState(false)

  const handleViewDetails = (log) => {
    setSelectedLog(log)
    setPopupOpen(true)
  }

  const handleClosePopup = () => {
    setSelectedLog(null)
    setPopupOpen(false)
  }

  return (
    <>
      <DataTable
        columns={columns(handleViewDetails)}
        data={response?.data.data}
        isLoading={isLoading}
        label="Activity Logs"
      />

      <ViewDetailsPopup
        open={isPopupOpen}
        onClose={handleClosePopup}
        data={selectedLog}
      />
    </>
  )
}
const ViewDetailsPopup = ({ open, onClose, data }) => {
  if (!data) return null
  const theme = {
    scheme: "monokai",
    author: "wimer hazenberg (http://www.monokai.nl)",
    base00: "transparent", // Background transparent
    base01: "#383830",
    base02: "#49483e",
    base03: "#75715e",
    base04: "#a59f85",
    base05: "#333333", // Main text color (darker for better readability)
    base06: "#f5f4f1",
    base07: "#f9f8f5",
    base08: "#d32f2f", // Red for keys (better contrast)
    base09: "#f57c00", // Orange for strings
    base0A: "#fbc02d", // Yellow for numbers and boolean
    base0B: "#388e3c", // Green for arrays/objects
    base0C: "#0288d1", // Cyan for null/undefined
    base0D: "#1976d2", // Blue for key names
    base0E: "#7b1fa2", // Purple for symbols
    base0F: "#d84315", // Brown for misc
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Changed Properties</DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 2,
          padding: 2,
          overflow: "auto",
        }}
      >
        {/* Attributes JSON View */}
        <Box
          sx={{
            flex: 1,
            padding: 2,
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
            overflow: "auto",
            border: "1px solid #e0e0e0",
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", marginBottom: 1 }}
          >
            Current Attributes
          </Typography>
          {data.properties.attributes ? (
            <JSONTree data={data.properties.attributes} theme={theme} />
          ) : (
            <Typography color="textSecondary">
              No attributes available
            </Typography>
          )}
        </Box>

        <Divider
          orientation="vertical"
          flexItem
          sx={{ display: { xs: "none", md: "block" } }}
        />

        {/* Old JSON View */}
        <Box
          sx={{
            flex: 1,
            padding: 2,
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
            overflow: "auto",
            border: "1px solid #e0e0e0",
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", marginBottom: 1 }}
          >
            Old Attributes
          </Typography>
          {data.properties.old ? (
            <JSONTree data={data.properties.old} theme={theme} />
          ) : (
            <Typography color="textSecondary">No old data available</Typography>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  )
}
